import ContactForm from "./ContactForm";

function Contact() {
  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <h2 className="section-title section-title-light">Get In Touch With Us</h2>
        <p className="section-subtitle section-subtitle-light">
          Contact us today to discuss your armored vehicle requirements. We'll work together to find the perfect solution for your security needs.
        </p>

        <ContactForm />
      </div>
    </section>
  );
}

export default Contact;
